import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {getTrackedVendorData, ITrackedVendor} from "./tracked_utils/tracked_vendor";
import {pageviewAlgolytics} from "./offer_detail_pageview";

export const vendorDetailPageview = (vendor: ITrackedVendor) => {
    const payload = {
        view_type: "vendor",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor)
    };
    pageviewAlgolytics(payload);
};
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {getTrackedVendorData, ITrackedVendor} from "./tracked_utils/tracked_vendor";
import {pageviewAlgolytics} from "./offer_detail_pageview";

export const vendorDetailPageview = (vendor: ITrackedVendor) => {
    const payload = {
        view_type: "vendor",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor)
    };
    pageviewAlgolytics(payload);
};
